import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchSalesInvoiceDetail, fetchSalesInvoiceCompletedDetail, fetchCustomerItem, fetchUnpaidInvoices, resetCurrentSalesInvoice } from '../../actions/salesInvoice_actions';
import { createSalesReturn, editSalesReturn, fetchSalesReturnDetail, setValue, setSaleRowValue } from '../../actions/sales_actions';
import CustomerReturnForm from '../../components/Returns/customerReturnForm';

const customerReturnForm = reduxForm({
  form: 'customerReturnForm',
})(CustomerReturnForm);

const selector = formValueSelector('customerReturnForm');

function mapStateToProps(state) {
  const Promo = selector(state, 'Promo');
  const Tax = selector(state, 'Tax');
  const RestockingFee = selector(state, 'RestockingFee');
  const Note = selector(state, 'Note');
  const Customers = selector(state, 'Customers');
  const Item = selector(state, 'Item');
  const searchValue = selector(state, 'ProductInformation');
  const searchType = selector(state, 'searchType');
  const Quantity = selector(state, 'Quantity');
  const Weight = selector(state, 'Weight');
  const UnitPrice = selector(state, 'UnitPrice');
  const CreditInvoiceNum = selector(state, 'CreditInvoiceNum');
  const PostingDate = selector(state, 'PostingDate');

  return {
    Promo,
    Tax,
    RestockingFee,
    Note,
    Customers,
    Item,
    searchValue,
    searchType,
    Quantity,
    Weight,
    UnitPrice,
    CreditInvoiceNum,
    PostingDate,
    currentSalesInvoice: state.salesInvoice.currentSalesInvoice,
    salesInvoiceDetail: (state.salesInvoice.currentSalesInvoiceDetail) ? state.salesInvoice.currentSalesInvoiceDetail.data : state.salesInvoice.currentSalesInvoiceDetail,
    salesReturnDetail: state.salesInvoice.salesReturnDetail,
    initialValues: state.salesInvoice.salesReturnDetail,
    currentCustomer: state.customers.currentCustomer,
    customerItem: state.salesInvoice.customerItem,
    unpaidInvoices: state.salesInvoice.unpaidInvoices,
    salesReturnIsCreating: state.salesInvoice.salesReturnIsCreating,
  };
}

export default connect(mapStateToProps, {
  fetchSalesInvoiceDetail,
  fetchCustomerItem,
  fetchUnpaidInvoices,
  editSalesReturn,
  fetchSalesInvoiceCompletedDetail,
  createSalesReturn,
  fetchSalesReturnDetail,
  setValue,
  setSaleRowValue,
  resetCurrentSalesInvoice,
})(customerReturnForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Returns/customerReturnForm.jsx